import { render, staticRenderFns } from "./ItemFormSelectSticker.vue?vue&type=template&id=5f8bc2e2&scoped=true&"
import script from "./ItemFormSelectSticker.vue?vue&type=script&lang=js&"
export * from "./ItemFormSelectSticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8bc2e2",
  null
  
)

export default component.exports